export default __webpack_public_path__ + "static/charLeft-1d18e80a398459124f27a2a50c03f781.png";